






















































import { computed, defineComponent, ref } from '@vue/composition-api';
import { AxiosError } from 'axios';

import InvoiceStateCard from '@/components/invoice/InvoiceStateCard.vue';
import {
  useExportInvoicePdf,
  useFetchInvoice,
  useUpdateInvoiceState
} from '@/composable/invoice';
import { InvoiceStateEnum } from '@/models';
import { setErrorFromAxiosError } from '@/utils/helpers';

import InvoiceDialog from '@/components/invoice/InvoiceDialog.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import InvoiceDetailSummaryCard from '@/components/invoice/InvoiceDetailSummaryCard.vue';
import InvoiceItemDialog from '@/components/invoice/InvoiceItemDialog.vue';
import snackbar from '@/mixins/snackbar';

export default defineComponent({
  name: 'InvoiceDetailPage',
  mixins: [snackbar],
  components: {
    InvoiceStateCard,
    InvoiceDialog,
    ErrorAlert,
    InvoiceDetailSummaryCard,
    InvoiceItemDialog
  },
  setup(_, { root }) {
    const invoiceId = Number(root.$route.params.id ?? 1);

    const error = computed(() => {
      const axiosError =
        fetchError.value || setStateError.value || exportPdfError.value;
      return axiosError
        ? setErrorFromAxiosError(axiosError as AxiosError)
        : null;
    });

    const isLoading = computed<boolean>(
      () =>
        isFetchLoading.value || isSetStateLoading.value || isGenPdfLoading.value
    );

    const {
      invoice,
      error: fetchError,
      isLoading: isFetchLoading
    } = useFetchInvoice(invoiceId);

    const {
      isLoading: isSetStateLoading,
      error: setStateError,
      mutate: updateInvoiceState,
      reset: updateReset
    } = useUpdateInvoiceState();

    function setInvoiceState(state: InvoiceStateEnum) {
      clearAllErrors();
      updateInvoiceState({ id: invoiceId, state });
    }

    function clearAllErrors() {
      updateReset();
      fetchError.value = null;
      setStateError.value = null;
      exportPdfError.value = null;
    }

    const dialog = ref(false);
    function openDialog() {
      dialog.value = true;
    }

    const invoiceItemDialog = ref(false);
    function openInvoiceItemDialog() {
      invoiceItemDialog.value = true;
    }

    const {
      isLoading: isGenPdfLoading,
      error: exportPdfError,
      mutate: exportInvoicePdf,
      reset: updateExportReset
    } = useExportInvoicePdf();

    function exportPdf() {
      clearAllErrors();
      exportInvoicePdf(invoice.value, {
        onSuccess: () => {
          updateExportReset();
        }
      });
    }

    return {
      invoiceItemDialog,
      invoiceId,
      dialog,
      invoice,
      isLoading,
      error,
      setInvoiceState,
      clearAllErrors,
      openDialog,
      openInvoiceItemDialog,
      exportPdf
    };
  }
});
